import React from 'react';
import { Layout } from '@/components/Layout';
import { Mail, Clock, Send, MessageSquare, Briefcase, Sparkles } from 'lucide-react';

export default function Contact() {
  const contacts = [
    { 
      title: '商务合作 / 资源投放', 
      email: '3894663764@qq.com', 
      content: '教育类产品投放、品牌广告合作、内容联合推广。',
      icon: <Briefcase className="h-6 w-6 text-blue-500" />
    },
    { 
      title: '教程投稿 / 内容收录', 
      email: '3894663764@qq.com', 
      content: '投稿自媒体实战教程、AI 工具使用指南、剪辑设计干货。',
      icon: <Send className="h-6 w-6 text-green-500" />
    },
    { 
      title: '问题反馈 / 投诉建议', 
      email: '3894663764@qq.com', 
      content: '链接失效、内容侵权、页面显示异常、改进建议。',
      icon: <MessageSquare className="h-6 w-6 text-orange-500" />
    },
  ];

  return (
    <Layout>
      <div className="container mx-auto px-4 md:px-6 py-12 max-w-4xl">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="bg-primary/10 p-4 rounded-2xl mb-4 text-primary">
            <Mail className="h-8 w-8" />
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight mb-4">联系我们</h1>
          <p className="text-muted-foreground text-lg max-w-xl">
            欢迎联系 万象聚聚官 2135C 运营团队！我们期待与你一起，让学习变得更高效、更简单！
          </p>
        </div>

        <div className="space-y-12">
          {/* Main Contact Section */}
          <section className="bg-card border rounded-3xl p-8 shadow-sm">
            <h2 className="text-2xl font-bold mb-8 flex items-center gap-2">
              <Mail className="h-6 w-6 text-primary" />
              核心联系方式
            </h2>
            <div className="grid gap-6">
              {contacts.map((contact, idx) => (
                <div key={idx} className="flex flex-col md:flex-row gap-6 p-6 bg-muted/30 rounded-2xl border border-border/50 hover:border-primary/20 transition-colors">
                  <div className="p-3 bg-background rounded-2xl shrink-0 h-fit">
                    {contact.icon}
                  </div>
                  <div className="flex-1 space-y-4">
                    <h3 className="text-xl font-bold">{contact.title}</h3>
                    <p className="text-sm text-muted-foreground">
                      <span className="font-bold text-foreground">适用场景：</span>{contact.content}
                    </p>
                    <div className="flex flex-wrap items-center gap-4">
                      <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-xl font-mono font-bold text-sm">
                        <Mail className="h-3.5 w-3.5" />
                        {contact.email}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Bottom Grid */}
          <section className="grid md:grid-cols-2 gap-8">
            <div className="bg-card border rounded-3xl p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-6">
                <Clock className="h-6 w-6 text-blue-500" />
                <h2 className="text-2xl font-bold">工作时间</h2>
              </div>
              <p className="text-muted-foreground mb-4">
                工作日：<span className="font-bold text-foreground">9:00 - 18:00</span>
              </p>
              <p className="text-sm italic">
                我们将尽力在 24 小时内 回复你的每一条信息。
              </p>
            </div>

            <div className="bg-primary border border-primary/20 rounded-3xl p-8 flex flex-col justify-center items-center text-center text-primary-foreground">
              <div className="bg-primary-foreground/20 p-4 rounded-full mb-6">
                <Sparkles className="h-8 w-8" />
              </div>
              <h2 className="text-2xl font-bold mb-4 italic">一句话寄语</h2>
              <p className="text-lg font-medium">
                你的每一次联系，都是我们进步的动力。期待与你一起，让学习变得更高效、更简单！
              </p>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}
